export default "__VITE_ASSET__DOokFxj___"